import { SVGProps, Ref, forwardRef } from 'react';

export const PenFilledSize12Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={12} height={12} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path d="m7.068 1.827.81-.809a2.195 2.195 0 1 1 3.104 3.105l-.809.809z" fill="currentColor" />
                <path d="M6.326 2.57.375 8.52v3.105H3.48l5.95-5.95z" fill="currentColor" />
            </g>
        </g>
    </svg>
));
PenFilledSize12Glyph.displayName = 'PenFilledSize12Glyph';
